import React from "react";
import { Card, Tag, Space, Button, Alert, Tooltip } from "antd";
import { EyeOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";
import {
  SERVICE_TYPES,
  SERVICE_STATUSES,
  getRepurchaseLink,
  isRenewalDisabled,
  getRenewalDisabledReason,
} from "@staticData/services";

function UserServiceCard({ service, onOpenDetails }) {
  const {
    serviceName,
    serviceType,
    status,
    amount,
    createdAt,
    startAt,
    endAt,
    packageName,
  } = service;

  const statusConfig = SERVICE_STATUSES[status] || {
    label: status,
    color: "default",
  };
  const typeLabel = SERVICE_TYPES[serviceType] || serviceType;
  const repurchaseUrl = getRepurchaseLink(service);

  const formatDate = (date, withTime = false) => {
    if (!date) return "-";
    return withTime
      ? moment(date).format("jYYYY/jMM/jDD | HH:mm")
      : moment(date).format("jYYYY/jMM/jDD");
  };

  const isMeetingOrConsultation =
    serviceType === "MEETING_ROOM" || serviceType === "CONSULTATION";

  const renewalDisabled = isRenewalDisabled(service);
  const disabledReason = getRenewalDisabledReason(service);

  const repurchaseButton = (
    <Button
      size="small"
      type="primary"
      icon={<ShoppingCartOutlined />}
      disabled={renewalDisabled}
    >
      تمدید
    </Button>
  );

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      }}
      bodyStyle={{ padding: 16 }}
    >
      {status === "NEAR_EXPIRY" && (
        <Alert
          message="در آستانه انقضا"
          type="warning"
          showIcon
          style={{ marginBottom: 12, padding: "6px 12px" }}
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 12,
        }}
      >
        <div>
          <h4 style={{ margin: 0, fontSize: 16, fontWeight: "bold" }}>
            {serviceName}
          </h4>
          {packageName && (
            <span style={{ fontSize: 12, color: "#888" }}>({packageName})</span>
          )}
        </div>
        <Tag color={statusConfig.color}>{statusConfig.label}</Tag>
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
        <Tag color="cyan">{typeLabel}</Tag>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px 16px",
          fontSize: 13,
          marginBottom: 16,
          color: "#555",
        }}
      >
        <div>
          <span style={{ color: "#999" }}>مبلغ: </span>
          <strong>{amount ? amount.toLocaleString() : 0} ریال</strong>
        </div>
        <div>
          <span style={{ color: "#999" }}>خرید: </span>
          <span>{formatDate(createdAt)}</span>
        </div>
        <div>
          <span style={{ color: "#999" }}>شروع: </span>
          <span>{formatDate(startAt, isMeetingOrConsultation)}</span>
        </div>
        <div>
          <span style={{ color: "#999" }}>پایان: </span>
          <span>{formatDate(endAt, isMeetingOrConsultation)}</span>
        </div>
      </div>

      <Space style={{ width: "100%", justifyContent: "flex-end" }} wrap>
        <Button
          size="small"
          icon={<EyeOutlined />}
          onClick={() => onOpenDetails(service)}
        >
          جزییات
        </Button>
        {renewalDisabled ? (
          <Tooltip title={disabledReason}>
            <span>{repurchaseButton}</span>
          </Tooltip>
        ) : (
          <Link to={repurchaseUrl}>
            {repurchaseButton}
          </Link>
        )}
      </Space>
    </Card>
  );
}

export default UserServiceCard;
